import React from 'react';
import { v4 as uuid } from 'uuid';
import styles from './RowProvider.module.scss';
import { PropertyType } from 'esa-ui-library/lib/types';
import cx from 'classnames';
import { isAfter, isBefore } from 'date-fns';
import { formatCents } from '../../../../../common';

const getClass = (exp: string, amount: number) => {
	let rowClass = '';

	if (isBefore(new Date(exp), new Date()) && amount > 0) {
		rowClass = 'Red';
	} else if (isAfter(new Date(exp), new Date()) && amount > 0) {
		rowClass = 'Green';
	}
	return rowClass;
};

export const getRows = (history: PropertyType[]): PropertyType[] => {
	return history.map((h: PropertyType) => {
		const rowClass = getClass(h.expiration, h.remaining_amount);
		return [
			<div key={uuid()} className={cx(styles.Data, styles[rowClass])}>
				{h.create_time}
			</div>,
			<div key={uuid()} className={cx(styles.Data, styles[rowClass])}>
				{h.transaction_id}
			</div>,
			<div key={uuid()} className={cx(styles.Data, styles[rowClass])}>
				{h.campaign_id}
			</div>,
			<div key={uuid()} className={cx(styles.Data, styles[rowClass])}>
				{h.name}
			</div>,
			<div key={uuid()} className={cx(styles.Data, styles.DataAmount, styles[rowClass])}>
				{formatCents(h.amount_awarded)}
			</div>,
			<div key={uuid()} className={cx(styles.Data, styles.DataAmount, styles[rowClass])}>
				{formatCents(h.remaining_amount)}
			</div>,
			<div key={uuid()} className={cx(styles.Data, styles.DataAmount, styles[rowClass])}>
				{formatCents(h.remaining_wagering)}
			</div>,
			<div key={uuid()} className={cx(styles.Data, styles[rowClass])}>
				{h.expiration}
			</div>,
		];
	});
};
